import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarSquareRegularCheckIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_8008_2124)",
		children: /* @__PURE__ */ _jsx("path", { d: "M21.5714 4C22.2839 4 22.8571 4.535 22.8571 5.2V7.2H24.5714C26.4625 7.2 28 8.635 28 10.4V24.8C28 26.565 26.4625 28 24.5714 28H7.42857C5.5375 28 4 26.565 4 24.8V10.4C4 8.635 5.5375 7.2 7.42857 7.2H9.14286V5.2C9.14286 4.535 9.71607 4 10.4286 4C11.1411 4 11.7143 4.535 11.7143 5.2V7.2H20.2857V5.2C20.2857 4.535 20.8589 4 21.5714 4ZM7.42857 9.6C6.95714 9.6 6.57143 9.96 6.57143 10.4V24.8C6.57143 25.24 6.95714 25.6 7.42857 25.6H24.5714C25.0429 25.6 25.4286 25.24 25.4286 24.8V10.4C25.4286 9.96 25.0429 9.6 24.5714 9.6H7.42857ZM19.7875 12.895C20.2054 12.36 21.0089 12.24 21.5821 12.63C22.1554 13.02 22.2839 13.77 21.8661 14.305L15.325 22.705C15.1054 22.99 14.7625 23.17 14.3875 23.195C14.0125 23.22 13.6429 23.095 13.3804 22.85L10.3857 20.055C9.88214 19.585 9.88214 18.825 10.3857 18.36C10.8893 17.895 11.7036 17.89 12.2018 18.36L14.1304 20.16L19.7875 12.9V12.895Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8008_2124",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			transform: "translate(3.99219 4)"
		})
	}) })]
});
export default SvgCalendarSquareRegularCheckIcon;
